import { createContext, useContext } from "react";

export type LiveReport = {
  current: boolean;
  tooltipText: string;
};

type DashboardCardContextValue = {
  isFullScreen: boolean;
  onScreen: boolean;
  editing: boolean;
  reportLive: (report: LiveReport) => void;
};

export const DashboardCardContext = createContext<DashboardCardContextValue>({
  isFullScreen: false,
  onScreen: true,
  editing: false,
  reportLive: () => {},
});

export const useDashboardCard = () => useContext(DashboardCardContext);
